import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

export default function BWDate({ label, setBookingDate }) {
  const handleDateChange = (e) => {
    let schDate = moment(new Date(e)).format("DD/MM/YYYY");
    setBookingDate(schDate);
  };
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <DatePicker
            label={label}
            format="DD/MM/YYYY"
            // defaultValue={dayjs(new Date())}
            slotProps={{ textField: { fullWidth: true } }}
            // minDate={dayjs(new Date())}
            onChange={(newValue) => handleDateChange(newValue)}
          />
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
}
